import { useQuery } from "@tanstack/react-query"

import type { RouterOutput } from "lib/trpc"
import { useTRPC } from "lib/trpc"

export type WarehouseSelectOption =
  RouterOutput["warehouse"]["selectOptions"][number]

export function useWarehouses(options?: { enabled?: boolean }) {
  const trpc = useTRPC()
  const { data, isPending } = useQuery(
    trpc.warehouse.selectOptions.queryOptions(undefined, {
      enabled: options?.enabled,
      staleTime: Infinity,
      retry: false,
    }),
  )
  return { warehouses: data ?? [], loading: isPending }
}
